import * as React from "react";

import { AbsoluteModelPath, isModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";

import { useTestPageObjectsRegistry } from "./TestPageObjectsRegistry";

interface TestPageObjectHandleProps {
    id: string | AbsoluteModelPath | Array<undefined | string | AbsoluteModelPath>;
    pageObject: unknown;
    children: React.ReactNode;
}

export const TestPageObjectHandle = (props: TestPageObjectHandleProps) => {
    if (process.env.NODE_ENV !== "development" && process.env.NODE_ENV !== "test") {
        return <>{props.children}</>;
    }
    return <TestPageObjectWrapper {...props} />;
};

export const TestPageObjectWrapper = (props: TestPageObjectHandleProps) => {
    const testPageObjectsRegistry = useTestPageObjectsRegistry();
    const pageObjectMethodsRef = React.useRef<unknown>();

    React.useEffect(() => {
        pageObjectMethodsRef.current = props.pageObject;
    }, [props.pageObject]);

    React.useEffect(() => {
        const correlationId = crypto.randomUUID();
        const ids: string[] = (Array.isArray(props.id) ? props.id : [props.id])
            .map(x => (x != undefined && isModelPath(x) ? x.toLegacyPath() : x))
            .filter(isNotNullOrUndefined);
        for (const id of ids) {
            testPageObjectsRegistry.registerPageObjectHandler(id, correlationId, pageObjectMethodsRef);
        }
        return () => {
            for (const id of ids) {
                testPageObjectsRegistry.unregisterPageObjectHandler(id, correlationId, pageObjectMethodsRef);
            }
        };
    }, [props.id]);

    return <>{props.children}</>;
};
